import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  label: {
    background: theme.palette.background.default,
  },
  pdfContainer: {
    marginTop: theme.spacing(2),
    border: '1px solid #ccc',
    padding: '0px',
    width: '100%',
    maxWidth: '100%',
    height: '810px', //792px
    overflow: 'auto', // Permite scroll horizontal y vertical
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: '#f5f5f5', // Fondo más claro
    borderRadius: theme.spacing(1.5), // Bordes redondeados
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Sombra ligera
    position: 'relative',
    // Responsivo
    [theme.breakpoints.down('xs')]: {
      height: '400px',
      padding: '4px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: '600px',
      padding: '8px',
    },
  },
  pdfViewer: {
    width: '100%',
    height: '100%',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    gap: theme.spacing(2),
  },
  zoomControlsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: '#f8f9fa',
    borderRadius: theme.spacing(1),
    border: '1px solid #dee2e6',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(0.5),
      padding: theme.spacing(0.5),
    },
  },
  zoomButton: {
    minWidth: 'auto',
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    border: 'none',
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
    transition: 'background 0.3s',
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0.25, 0.5),
      fontSize: '0.75rem',
    },
  },
  zoomInfo: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
    padding: theme.spacing(0.5, 1),
    backgroundColor: '#fff',
    border: '1px solid #dee2e6',
    borderRadius: theme.spacing(0.5),
    minWidth: '60px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(0.25, 0.5),
      minWidth: '50px',
    },
  },
  paginationButton: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    border: 'none',
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
    transition: 'background 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
    },
  },
  addSignatureButton: {
    background: '#007bff',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background 0.3s',
  },
  cancelButton: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background 0.3s',
  },
  boxContainer: {
    width: '30%',
    height: '100%',
    position: 'relative',
    top: 0,
    right: 0,
    boxShadow: 1,
    padding: theme.spacing(2),
    maxHeight: '125vh',
    overflowY: 'auto',
    backgroundColor: '#fff',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f0f0f0',
    },
  },
  uploadContainer: {
    border: '2px dashed #ccc',
    padding: '30px',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  uploadIcon: {
    fontSize: '120px',
    color: theme.palette.primary.main,
    marginBottom: '16px',
  },
  uploadLabel: {
    ...theme.typography.h5,
    margin: '8px 0',
  },
  uploadText: {
    color: '#777',
    ...theme.typography.body2,
  },
  uploadTextAlt: {
    color: '#333',
    ...theme.typography.body1,
  },
  errorText: {
    ...theme.typography.caption,
    color: 'red',
    marginTop: '12px',
  },
  labelBar: {
    ...theme.typography.body2,
  },
  helper: {
    ...theme.typography.body1,
    textAlign: 'center',
    marginBottom: '16px',
  },
}));
